import { useQuery } from '@tanstack/react-query';
import type AgentApiAiJobSearchPersonasItem from '@/types/serializers/AgentApiAiJobSearchPersonasItem';
import { POLLING_INTERVAL_MS } from '../constants';

/** ペルソナの状態をポーリング取得するクエリ */
export default function useFetchAiJobSearchPersona(personaId: number | null) {
  return useQuery({
    queryKey: ['aiJobSearchPersona', personaId],
    enabled: personaId !== null,
    queryFn: async (): Promise<AgentApiAiJobSearchPersonasItem> => {
      const response = await fetch(`/agent/api/ai_job_search_personas/${personaId}`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error('ペルソナの取得に失敗しました');
      }

      const data: AgentApiAiJobSearchPersonasItem = await response.json();
      return data;
    },
    // queued/processing の間はポーリング、それ以外は停止
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      if (status === 'queued' || status === 'processing') {
        return POLLING_INTERVAL_MS;
      }
      return false;
    },
    refetchOnWindowFocus: false,
  });
}
